import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { lazy, Suspense } from 'react';
import { BootstrapLoader } from './components/shared/BootstrapLoader';
import { useTrackingSubscriber } from '@/hooks/useTracking';

const CartPage = lazy(() => import('./pages/CartPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage'));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 1000 * 30 },
    },
});

/** Calls useTrackingSubscriber inside the QueryClientProvider tree so useQueryClient() resolves. */
function TrackingMount() {
    useTrackingSubscriber();
    return null;
}

export default function App() {
    const root = document.getElementById('altcheckout-root');
    const page = root?.dataset.page;

    return (
        <QueryClientProvider client={queryClient}>
            <TrackingMount />
            <Suspense fallback={<BootstrapLoader />}>
                {page === 'cart' && <CartPage />}
                {page === 'checkout' && <CheckoutPage />}
                {page === 'order-received' && <ThankYouPage />}
            </Suspense>
            <Toaster />
        </QueryClientProvider>
    );
}
